const types = {
  SET_REFERRAL_CASES_LOADING: "SET_REFERRAL_CASES_LOADING",
  SET_REFERRAL_CASES_COUNT: "SET_REFERRAL_CASES_COUNT",
  SET_REFERRAL_CASES: "SET_REFERRAL_CASES",
  SET_CASE_REVIEW_MODAL_VISIBLE: "SET_CASE_REVIEW_MODAL_VISIBLE"
};

export default types;
